module.exports = __webpack_public_path__ + "img/icon_calc_large.a48e805a.svg";